import { CARREGAR_REGIME_DE_CASAMENTO_SUCESSO } from './actionTypes';
import IRegimeDeCasamento from '../interfaces/IRegimeDeCasamento';

export const carregarRegimeDeCasamentoSucesso = (regimesDeCasamento: IRegimeDeCasamento[]) => {
  return {
    type: CARREGAR_REGIME_DE_CASAMENTO_SUCESSO,
    state: regimesDeCasamento
  };
};